import React, { useEffect, useRef, useState } from "react";
import './scheduler.scss'
import mapboxgl from 'mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { LoadingButton } from "@mui/lab";
import { Card, CardContent, Divider } from "@mui/material";
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import AdjustRoundedIcon from '@mui/icons-material/AdjustRounded';
import startImg from '../../../assets/start.png'
import route from '../../../assets/route.png'
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import MenuSelect from "./menuSelect/menuSelect";
import AdminApi from "../../../store/services/admin";
import { useAppDispatch, useAppSelector } from "../../../store/hooks/hooks";
import { StudentActions } from "../../../store/StudentAction";
import Route from "./Route/route";
import NewPlacementVisitModal from "./newVisitModal/newVisitModal";

const Scheduler: React.FC<any> = ({ placementList }) => {
    const mapContainer = useRef<any>(null);
    const map = useRef<any>(null);
    const [zoom, setZoom] = useState(5);
    mapboxgl.accessToken = "pk.eyJ1IjoicGF1bHNoYWp1IiwiYSI6ImNsYmtxaDBwaDAwNzYzd21nZTd0cDJ3bjEifQ.oSWMvsaIpQ_txggdRwSKmg"
    const [start, setStart] = useState("")
    const [end, setEnd] = useState("")
    const [loading, setLoading] = useState(false)
    const dispatch = useAppDispatch()
    const [optimizedPath, setOptimizedPath] = useState({})
    const [planRoute, setPlanRoute] = useState(true)
    const userDetails = useAppSelector((state: any) => state.user.user)

    const addMarkerToMap = (longlatMessage: any) => {
        const popup = new mapboxgl.Popup({ offset: 25 }).setText(
            `Student Name:${longlatMessage.message.name},
            Company Name:${longlatMessage.message.Company},
            Role:${longlatMessage.message.Role},
            PlacementId:${longlatMessage.message.placementId}`
        );
        const el = document.createElement('div');
        el.id = 'marker';
        const marker = new mapboxgl.Marker()
            .setLngLat([longlatMessage.longitude, longlatMessage.latitude])
            .setPopup(popup)
            .addTo(map.current);
    }
    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [-0.118092, 51.509865],
            zoom: zoom
        });
        const popup = new mapboxgl.Popup({ offset: 25 }).setText("University of Leicester");
        const marker2 = new mapboxgl.Marker({ color: 'black' })
            .setLngLat([-1.1246, 52.6211])
            .setPopup(popup)
            .addTo(map.current);
        if (placementList.length > 0 && map.current) {
            placementList.length > 0 && placementList.map((elm: any) => {
                addMarkerToMap({
                    longitude: elm.placement.Longitude,
                    latitude: elm.placement.Latitude,
                    message: {
                        name: `${elm.user.first_name} ${elm.user.last_name}`,
                        Company: elm.placement.CompanyName,
                        Role: elm.placement.JobRoles,
                        placementId: elm.placement.Id
                    }
                })
            })
        }
    }, [placementList])
    const handleSubmit = () => {
        setLoading(true)
        let body = {
            start: 'UOL',
            end: end
        }
        AdminApi.getShortestPath(body).then(res => {
            setOptimizedPath(res)
            setLoading(false)
            setPlanRoute(prev => !prev)
        }).catch(_e => {
            setLoading(false)
            dispatch(StudentActions.setMessage("Route Generation Failed.Try again."))
        })
    }
    return (
        <>
            <div className="mapContainer">
                <div ref={mapContainer} className="map-container" />
                <Card className="planTripContainer m-2 shadow ">
                    <CardContent>
                        {
                            planRoute ? <>
                                <form className="align-items-center flex flex-column">
                                    <div className="flex flex-column justify-content-around">
                                        <img src={route} className="cardIcon"></img>
                                    </div>
                                    <h1 className="planTripTitle">Plan your Route</h1>
                                    <p className="body-p gray-color m-0 subTitle" style={{ width: "200px" }}>Please select your Start and To locations,to find the shortest path which would cover more placements.</p>
                                    <div className='flex flex-column'>
                                        <div className="align-items-center flex flex-row justify-content-between p-1 m-2">
                                            <LocationOnRoundedIcon fontSize="medium" className="sourceIconColor m-1"></LocationOnRoundedIcon>
                                            <MenuSelect label="UOL" disabled={true} items={placementList} valueChange={(e: string) => {
                                                setStart(e)
                                            }}></MenuSelect>
                                        </div>
                                    </div>
                                    <div className='flex flex-column'>
                                        <div className="align-items-center flex flex-row justify-content-between p-1 m-2">
                                            <AdjustRoundedIcon fontSize="medium" className="desitiontionaIconColor m-1"></AdjustRoundedIcon>
                                            <MenuSelect label="To" disabled={false} items={placementList} valueChange={(e: string) => {
                                                setEnd(e)
                                            }}></MenuSelect>
                                        </div>

                                    </div>
                                    <div className="flex justify-content-center">
                                        <LoadingButton onClick={handleSubmit} loading={loading} variant="contained">
                                            Plan your Trip
                                        </LoadingButton>
                                    </div>
                                </form>
                            </> : <>
                                <Route path={optimizedPath} placementList={placementList} planAgain={() => {
                                     setPlanRoute(prev => !prev)
                                }}></Route>
                            </>
                        }

                    </CardContent>
                </Card>
            </div>

        </>
    )

}
export default Scheduler